import MojitoCore from 'mojito/core';
import ProViewImpl from './pro-view.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Pro view.
 *
 * @class ProView
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */

export default UIView('ProView', ProViewImpl);
